import axios from 'axios';
import authHeader from "@/services/auth-header";
import ConstApiUrls from "@/services/const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL_UMKM

class FUmkmTypeService {
    getApiUrl() {
        return API_URL
    }
    getAllFUmkmType(){
        return axios.get(API_URL + `getAllFUmkmType`, { headers: authHeader() });
    }
    getAllFUmkmTypePublic(){
        return axios.get(API_URL + `public/getAllFUmkmType`, { headers: authHeader() });
    }
    getAllFUmkmTypeContaining(page, pageSize, sortBy, order, search){
        // return axios.get(API_URL + `getAllFUmkmType`, { headers: authHeaderMultipart() });
        return axios.get(API_URL + `getAllFUmkmTypeContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`, { headers: authHeader() });
    }
    getFUmkmTypeById(id){
        return axios.get(API_URL + `getFUmkmTypeById/${id}`, { headers: authHeader() });
    }
    updateFUmkmType(item){
        return axios.put(API_URL + `updateFUmkmType/${item.id}`, item, {headers: authHeader()})
    }
    createFUmkmType(item){
        return axios.post(API_URL + `createFUmkmType`, item, {headers: authHeader()})
    }
    deleteFUmkmType(id){
        return axios.delete(API_URL + `deleteFUmkmType/${id}`, {
            headers: authHeader()
        });
    }
    deleteAllFUmkmType(itemIds){
        // let user = JSON.parse(localStorage.getItem('user'));
        // return axios.delete(API_URL + `deleteAllFUmkmType`, {
        //     headers:  authHeaderMultipart(),
        //     data: {
        //         message: 'delete  success'
        //     }
        // });
        return axios.delete(API_URL + `deleteAllFUmkmType`, {
            headers:  authHeader(),
            data: itemIds
        });


    }
}
export default new FUmkmTypeService()